import { jsx as _jsx } from "react/jsx-runtime";
import TextMessage from 'components/conversation/components/messages/TextMessage';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { isMessageSupported, } from '../../utils/conversationPreviewDefinitions';
import styles from './conversationPreviewMessages.module.scss';
export const ConversationPreviewMessages = ({ messages, innerHits = [], requesterId, }) => {
    const currentUserId = useAppSelector((state) => state.settings.profile.profile.id);
    const supportedMessages = messages.filter(isMessageSupported);
    const listIsEmpty = supportedMessages.length === 0;
    return (_jsx("div", Object.assign({ className: styles.root }, { children: listIsEmpty ? (_jsx("div", { children: "This conversation has no messages." })) : (supportedMessages.map((_message, index) => {
            var _a, _b;
            const message = Object.assign({}, _message);
            const own = ((_a = message.author) === null || _a === void 0 ? void 0 : _a.id) === currentUserId;
            const isAgent = ((_b = message.author) === null || _b === void 0 ? void 0 : _b.id) !== requesterId;
            const internal = message.type === 'conversation:wrapup_message';
            if (innerHits) {
                innerHits.map((hit) => {
                    var _a;
                    if (((_a = hit.highlight) === null || _a === void 0 ? void 0 : _a.text) && hit.id === message.id) {
                        message.text = hit.highlight.text;
                    }
                });
            }
            return (_jsx(TextMessage, { own: own, isAgent: isAgent, internal: internal, message: message, author: message.author, date: message.created_at || '' }, message.id || index));
        })) })));
};
